/**
 * LocationInfo Molecule Component
 * Displays location information with icon
 */

import { cn } from '@/lib/utils'
import { MapPin } from 'lucide-react'

interface LocationInfoProps {
	type: 'pickup' | 'dropoff'
	location: string
	compact?: boolean
	className?: string
}

export function LocationInfo({
	type,
	location,
	compact = false,
	className,
}: LocationInfoProps) {
	return (
		<div className={cn('flex items-start gap-2', className)}>
			{compact ? (
				<span className='font-["Bricolage_Grotesque"] text-sm font-bold text-[#09194D] leading-tight uppercase'>
					{location}
				</span>
			) : (
				<div className='flex flex-col'>
					<span className='font-["Bricolage_Grotesque"] text-xs text-gray-600 uppercase'>
						{type === 'pickup' ? 'Pickup' : 'Dropoff'}
					</span>
					<span className='font-["Bricolage_Grotesque"] text-sm font-bold text-[#09194D]'>
						{location}
					</span>
				</div>
			)}
		</div>
	)
}
